<div class="main" [ngClass]="{'locked': locked}" (click)="toggle($event)">
    <div class="main-colour background" [ngClass]="{'selected': backgroundSelected}"
         [style.background-color]="backgroundColor"></div>
    <div class="main-colour foreground" [ngClass]="{'selected': !backgroundSelected}"
         [style.background-color]="foregroundColor"></div>
</div>
